import { Dialog, DialogContent } from "@mui/material";
import { useTranslation } from "i18n-fe";
import ScribeLockPin from "./ScribeLockPin";

// #3634 -- the gear's dialog. ONLY the admin PIN input, its Wrong PIN error and
// Cancel: no clock, no next class, nothing else. The PIN is the same show PIN
// the lock screen asks for (the caller passes getScribePin(show)). A tap
// outside the dialog or Esc closes it with no change (Dialog onClose).
export default function AdminPinDialog({ open, pin, onUnlock, onCancel }) {
  const { t } = useTranslation("score");
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs" fullWidth data-testid="scribe-admin-pin-dialog">
      <DialogContent>
        <ScribeLockPin
          pin={pin}
          label={t("adminOptions.gearPinLabel")}
          onUnlock={onUnlock}
          onCancel={onCancel}
        />
      </DialogContent>
    </Dialog>
  );
}
